import { gql } from "@apollo/client";

export const FETCH_POS = gql`
  query FETCH_POS(
    $offset: Int
    $limit: Int
    $receiptStatus: [String]
    $q: String
  ) {
    supplierPos(
      offset: $offset
      limit: $limit
      receiptStatus: $receiptStatus
      q: $q
    )
  }
`;

export const FETCH_PO = gql`
  query FETCH_PO($odooCompanyId: Int!, $id: Int!) {
    supplierPo(odooCompanyId: $odooCompanyId, id: $id)
  }
`;

export const FETCH_PO_DELIVERIES = gql`
  query FETCH_PO_DELIVERIES($odooCompanyId: Int!, $poId: Int!) {
    supplierPoDeliveries(odooCompanyId: $odooCompanyId, poId: $poId)
    shipment: supplierPoConfirmedStockShipment(
      odooCompanyId: $odooCompanyId
      poId: $poId
    ) {
      id
      lines {
        id
        product {
          id
          odooId
          number
          nameCn
        }
        qty
      }
    }
  }
`;

export const SUBMIT_DELIVERY = gql`
  mutation SUBMIT_DELIVERY(
    $odooCompanyId: Int!
    $poId: Int!
    $deliveryId: Int!
    $data: String!
  ) {
    supplierSubmitDelivery(
      odooCompanyId: $odooCompanyId
      poId: $poId
      deliveryId: $deliveryId
      data: $data
    ) {
      result
    }
  }
`;

export const CONFIRM_PO_DELIVERY = gql`
  mutation CONFIRM_PO_DELIVERY(
    $odooCompanyId: Int!
    $poId: Int!
    $refName: String!
    $shipmentLines: [StockShipmentLineInput!]!
  ) {
    supplierConfirmPoDelivery(
      odooCompanyId: $odooCompanyId
      poId: $poId
      refName: $refName
      shipmentLines: $shipmentLines
    ) {
      shipment {
        id
        state
        refName
      }
    }
  }
`;

export const RESET_PO_DELIVERY = gql`
  mutation RESET_PO_DELIVERY($shipmentId: Int!) {
    supplierResetPoDelivery(shipmentId: $shipmentId) {
      shipment {
        id
        state
        updatedAt
      }
    }
  }
`;
